// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1PnY1","buttons":"RemoveExpirationActionButtons_buttons__2zxFA"};